module.exports = __webpack_public_path__ + "static/media/logo-white.bfaea290.svg";